import { Routes } from '@angular/router';
import { MainComponent } from './main.component';
import { ADMINISTRATION_ROUTES } from '../administration/administration.routes';
import { CONTROLES_ROUTES } from '../controles/controles.routes';
import { DECLARATIONS_ANPP_ROUTES, DECLARATIONS_ROUTES } from '../declarations/declarations.routes';
import { DOCUMENTS_ROUTES } from '../documents/documents.routes';
import { DREV_MANQUANTES_ROUTES } from '../drev-manquantes/drev-manquantes.routes';
import { ENGAGEMENTS_ROUTES } from '../engagements/engagements.routes';
import { MON_COMPTE_ROUTES } from '../mon-compte/mon-compte.routes';
import { OPERATEURS_ROUTES } from '../operateurs/operateurs.routes';
import { HOME_ROUTES } from '../home/home.routes';
import { HABILITATIONS_ROUTES } from '../habilitations/habilitations.routes';
import { FACTURATION_ROUTES } from '../facturation/facturation.routes';
import { EXPORT_ROUTES } from '../export/export.routes';
import { SUIVI_DECLARATIONS_ROUTES } from '../suivi-declarations/suivi-declarations.routes';
import { OPERATEUR_ORGANISMES_ROUTES } from '../operateur-organismes/operateur-organismes.routes';
import { SUIVIS_ROUTES } from '../suivis/suivis.routes';
import { EDIT_MDP_ROUTES } from '../edit-mdp/edit-mdp.routes';
import { DR_DREV_SAISIES_ROUTES } from '../dr-drev-saisies/dr-drev-saisies.routes';
import { DREV_SYNTHESE_ROUTES } from '../drev-synthese/drev-synthese.routes';
import { HISTORIQUE_MODIFICATION_ROUTES } from '../historique-modification/historique-modification.routes';

export const MAIN_ROUTES: Routes = [
    { path: '', component: MainComponent },
    { path: 'home', children: HOME_ROUTES },
    { path: 'operateurs', children: OPERATEURS_ROUTES },
    { path: 'suivi-declarations', children: SUIVI_DECLARATIONS_ROUTES },
    { path: 'controles', children: CONTROLES_ROUTES },
    { path: 'facturation', children: FACTURATION_ROUTES },
    { path: 'contacts', children: OPERATEUR_ORGANISMES_ROUTES },
    { path: 'export', children: EXPORT_ROUTES },
    { path: 'habilitations', children: HABILITATIONS_ROUTES },
    { path: 'declarations', children: DECLARATIONS_ROUTES },
    { path: 'declarations-pp', children: DECLARATIONS_ANPP_ROUTES },
    { path: 'engagements', children: ENGAGEMENTS_ROUTES },
    { path: 'suivis', children: SUIVIS_ROUTES },
    { path: 'drev-manquantes', children: DREV_MANQUANTES_ROUTES },
    { path: 'drev-synthese', children: DREV_SYNTHESE_ROUTES },
    { path: 'dr-drev-saisies', children: DR_DREV_SAISIES_ROUTES },
    { path: 'edit-mdp', children: EDIT_MDP_ROUTES },
    { path: 'admin', children: ADMINISTRATION_ROUTES },
    { path: 'mon-compte', children: MON_COMPTE_ROUTES },
    { path: 'ged', children: DOCUMENTS_ROUTES },
    { path: 'historique-modification', children: HISTORIQUE_MODIFICATION_ROUTES }
];
